import { render } from "./PCDatosOrigenUnidadLogistica.vue?vue&type=template&id=7c4cc6a7&scoped=true"
import script from "./PCDatosOrigenUnidadLogistica.vue?vue&type=script&lang=js"
export * from "./PCDatosOrigenUnidadLogistica.vue?vue&type=script&lang=js"

import "./PCDatosOrigenUnidadLogistica.vue?vue&type=style&index=0&id=7c4cc6a7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c4cc6a7"]])

export default __exports__